import KabobMenuItem from 'Views/Page/Content/Templates/WhatIfTemplate/Components/KabobMenu/KabobMenuItem';
import React from 'react';
import PropTypes from 'prop-types';

const DeleteKabobItem = ({ onClick }) => {
  return (
    <KabobMenuItem
      label={'Delete'}
      onClick={() => {
        onClick();
      }}
    />
  );
};

DeleteKabobItem.defaultProps = {};

DeleteKabobItem.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default DeleteKabobItem;
